import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {PageContent} from "../../components/PageContent";
import {Button, PageHeader, Space} from "antd";
import StructuredFoldersFilter from "./StructuredFoldersFilter";
import StructuredFoldersTable from "./StructuredFoldersTable";
import StructuredFoldersModalCreate from "./StructuredFoldersModalCreate";
import StructuredFoldersModalRemove from './StructuredFoldersModalRemove';
import {getFileResponse} from '../../api/loginRoutes';
import {downloadDataAsFile} from '../../utils';


export default (
    {
        data,
        loading,
        selectedStructuredFolderId,
     /* ivrList, */
        selectIvrId,
     /* getIvrList, */
        getStructuredFoldersList,
     /* getStructuredFoldersDropdownList */
        selectStructuredFolderId,
    }
) => {

    const [filter, setFilter] = useState({});
    const [currentFolderId, setCurrentFolderId] = useState(null);
    const [isModalCreateVisible, setIsModalCreateVisible] = useState(false);
    const [isModalRemoveVisible, setIsModalRemoveVisible] = useState(false);
    const [selectedRecordRow, onSelectRecordRow] = useState({});
    const [loadingItems, setLoadingItems] = useState({});
    const [downloadLoading, setDownloadLoading] = useState(false);

    useEffect(() => {
        getStructuredFoldersList(filter);
        selectStructuredFolderId(null);
    }, [filter]);

    const currentFolderData = useMemo(() => {
        if (!currentFolderId) {
            return {};
        }

        return data.find(item => item.dir_key === currentFolderId);
    }, [data, currentFolderId]);

    const addLoadingItems = useCallback((id) => {
        setLoadingItems(prev => ({...prev, [id]: true}));
    }, [loadingItems]);

    const removeLoadingItems = useCallback((id) => {
        setLoadingItems(prev => ({...prev, [id]: false}));
    }, [loadingItems]);

    const handleClickDownload = (id, filename) => {
        addLoadingItems(id);
        setDownloadLoading(true);
        getFileResponse('ivr_structured_sound_dir:download', {dir_key: id, arch_type: 'tar-gz'}, 'file')
            .then(r => {
                if (!r) {
                    return;
                }
                // hard code - archive extension (should be accorded to what the API returns)
                downloadDataAsFile(r, filename+'.tar.gz');
            })
            .finally(() => {
                removeLoadingItems(id);
                setDownloadLoading(false);
            });
    };
    
    return (
        <PageContent>

            <PageHeader
                className="site-page-header"
                title="Structured folders"
            />

            <Space
                direction="vertical"
                size={20}
                style={{width: '100%'}}
            >

                <div style={{display: 'flex'}}>

                    <StructuredFoldersFilter
                        // ivrList={ivrList}
                        // getIvrList={getIvrList}
                        setFilter={setFilter}
                    />

                    <Button
                        style={{marginLeft: 'auto'}}
                        onClick={() => {
                            setCurrentFolderId(null);
                            setIsModalCreateVisible(true);
                        }}
                    >
                        Add new
                    </Button>

                </div>

                <StructuredFoldersTable
                    data={data}
                    loading={loading || downloadLoading}
                    onSelectRecordRow={onSelectRecordRow}
                    handleClickCreate={(id) => {
                        setCurrentFolderId(id);
                        setIsModalCreateVisible(true);
                    }}
                    handleClickRemove={(id) => {
                        setCurrentFolderId(id);
                        setIsModalRemoveVisible(true);
                    }}
                    handleClickDownload={handleClickDownload}
                    selectIvrId={selectIvrId}
                />

            </Space>
 
            <StructuredFoldersModalCreate
                {...{
                    // ivrList,
                    isModalCreateVisible,
                    currentFolderId,
                    currentFolderData,
                }}
                onSuccess={() => {
                    getStructuredFoldersList(filter);
                    // getStructuredFoldersDropdownList();
                }}
                onCancel={() => {
                    setCurrentFolderId(null);
                    setIsModalCreateVisible(false);
                }}
            />

            <StructuredFoldersModalRemove
                {...{
                    currentFolderId,
                    isModalRemoveVisible,
                    selectedRecordRow
                }}
                onSuccess={() => {
                    getStructuredFoldersList(filter);
                //  getStructuredFoldersDropdownList();
                }}
                onCancel={() => {
                    setCurrentFolderId(null);
                    setIsModalRemoveVisible(false);
                }}
            />

        </PageContent>
    );
};